document.addEventListener("DOMContentLoaded", function () {
  let targetNode = document.body;
  let observerOptions = {
    childList: true,
    subtree: true,
  };

  let observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      if (mutation.type === "childList") {
        let descriptions = document.querySelectorAll(
          ".subify-main-selling-plan-container .desktop-description"
        );

        if (descriptions.length > 0) {
          descriptions.forEach(function (description, index) {
            if (!description.querySelector(".card-title")) {
              let title = document.createElement("h4");
              title.classList.add("card-title");
              title.textContent = "Subscription details";

              // Create a new smaller arrow element
              let arrow = document.createElement("span");
              arrow.classList.add("back-arrow");
              arrow.innerHTML = "&#8592;";

              title.insertBefore(arrow, title.firstChild);
              description.insertBefore(title, description.firstChild);

              // Add event listener to arrow to toggle between arrow and "X"
              arrow.addEventListener("mouseenter", function () {
                arrow.innerHTML = "&#10006;"; // "X" symbol
              });

              arrow.addEventListener("mouseleave", function () {
                arrow.innerHTML = "&#8592;"; 
              });

              // Add event listener to arrow to hide the modal
              arrow.addEventListener("click", function () {
                description.style.visibility = "hidden";
                description.style.opacity = "0";
              });

              // Remove inline styles on hover to ensure the card is shown
              let container = description.closest(
                ".subify-main-selling-plan-container"
              );
              container.addEventListener("mouseenter", function () {
                description.style.visibility = "";
                description.style.opacity = "";
              });
            }
          });

          observer.disconnect();
        }
      }
    });
  });

  observer.observe(targetNode, observerOptions);
});
